import { __awaiter, __generator } from "tslib";
import { reportHomePageLoadedDuration, reportHomePagePaintDuration } from '../../logger/homePageLoad';
import '../polyfill';
import { fetchHandleError } from '../FetchConfig';
import { goto } from '../../lib/lib-util';
import { appDataInitialize, bootstrap } from './bootstrap';
function unAuthorizedAction(error) {
    if (error.status === 401) {
        goto('/login');
    }
}
fetchHandleError(unAuthorizedAction);
window.addEventListener('load', function () {
    reportHomePageLoadedDuration();
    reportHomePagePaintDuration();
});
appDataInitialize();
window.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        bootstrap();
        return [2];
    });
}); });
